import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import { memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import ResidencyPermitForm from './residency-permit-form';
import { noop } from 'shell/utils/noop';
import { DocumentFormVM } from 'front-office/view-models/document/document-form';

interface ResidencyPermitProps {
  disabled?: boolean;
}

const ResidencyPermitComponent = ({ disabled }: ResidencyPermitProps): React.ReactElement => {
  const [open, setOpen] = useState(false);

  const formContext = useFormikContext<DocumentFormVM>();

  return formContext.values.oldResidencyPermit ? (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-permit-residency-content"
        id="panel-permit-residency-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>Permesso di soggiorno precedente</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <ResidencyPermitForm
          disabled={disabled}
          values={formContext.values.oldResidencyPermit}
          onChange={noop}
        />
      </AccordionDetails>
    </Accordion>
  ) : (
    <></>
  );
};

ResidencyPermitComponent.displayName = 'Accordion Residency Permit component';

const ResidencyPermit = memo(ResidencyPermitComponent);

export default ResidencyPermit;
